import { Card, Typography } from "@mui/material";
import { useMemo } from "react";

import CustomTable from "../CustomTable";

type ComponentProps = {
  data: any;
};

const TopTaskCreateReject = ({ data }: ComponentProps) => {
  const columns = [
    {
      key: "user_name",
      value: (data: any) => data?.user_name,
    },
    {
      key: "count",
      value: (data: any) => data?.count,
      className: "text-center",
    },
  ];

  const dataTopCreateReject = useMemo(() => {
    const topKeyin = data?.top_create_task_reject_today || [];
    if (!topKeyin.length) return [];

    topKeyin.sort(
      (a: { count: number }, b: { count: number }) => b.count - a.count,
    );
    return topKeyin.slice(0, 3).map((item: { count: number }) => ({
      ...item,
      count: item.count || 0,
    }));
  }, [data?.top_create_task_reject_today]);

  return (
    <Card className="p-4">
      <Typography variant="body1" className="font-semibold mb-2">
        Top Task Create Reject
      </Typography>
      <CustomTable
        loading={false}
        showRowNo={true}
        headers={[]}
        rows={dataTopCreateReject}
        columns={columns}
        disabledShadow={true}
        noEntriesRow={true}
      />
    </Card>
  );
};

export default TopTaskCreateReject;
